export const ALEIS_70X0_SCANNER_DRIVER_NAME = "aleis70x0-scanner";
